module.exports = __webpack_public_path__ + "static/media/LogicWedge2_5_row_3.86cf3867.png";